import { useIntl } from "react-intl";
import { useMemo } from "react";
import { groupBy } from "lodash";

import { SubscriptionItem } from "../../../types";
import { Hierarchy } from "../../../../common";

import { SUBSCRIPTION_ITEMS_GROUPS } from "./SubscriptionsItemsTree.constants";
import { IHierarchyItem } from "./SubscriptionsItemsTree.types";

export function useSubscriptionItemsHierarchy(subscriptionItems: SubscriptionItem[]): Hierarchy<string, IHierarchyItem>[] {
  const { formatMessage } = useIntl();

  const hierarchies = useMemo(() => {
    const groupedSubscriptionItems = groupBy(subscriptionItems, (item) => item.type);

    return SUBSCRIPTION_ITEMS_GROUPS.map<IHierarchyItem>((group) => ({ ...group, name: formatMessage(group.name) }))
      .map((group) => {
        const groupItems = groupedSubscriptionItems[String(group.type)]?.map<IHierarchyItem>((fi) => ({ ...fi, id: String(fi.id) })) || [];
        const groupHierarchy = new Hierarchy(group.id, group.name, group);
        groupItems.forEach((subscriptionItem) => {
          new Hierarchy(subscriptionItem.id, subscriptionItem.name, subscriptionItem, groupHierarchy);
        });
        return groupHierarchy;
      })
      .filter((h) => h.children !== undefined && h.children?.length !== 0);
  }, [subscriptionItems, formatMessage]);

  return hierarchies;
}
